var axios = require('axios');

var axiosInstance = axios.create({
    baseURL: '',
});
module.exports = axiosInstance;
